import { ITableField } from '../../../../../../shared/Tables/Table'
import timeUtils from '../../../../../../utils/time.utils.ts'
import { IMaintenanceBlankSchema } from '../../../maintenance.types.ts'

const maintenanceBlanksTableFields: ITableField<IMaintenanceBlankSchema, keyof IMaintenanceBlankSchema>[] = [
  {
    key: 'createdAt',
    clientSideOrdering: true,
    width: '200px',
    header: 'Дата создания',
    getter: (it) => timeUtils.formatDate(new Date(it.createdAt), 'dd MMM yyyy HH:mm'),
    sortGetter: (it) => new Date(it.createdAt).getTime(),
  },
  {
    key: 'name',
    clientSideOrdering: true,
    width: '600px',
    header: 'Наименование бланка',
    getter: (it) => it.name,
    sortGetter: (it) => it.name,
  },
  {
    key: 'fields',
    clientSideOrdering: true,
    width: '300px',
    header: 'Количество полей',
    getter: (it) => it.fields.length.toString(),
    sortGetter: (it) => it.fields.length,
  },
]

export default maintenanceBlanksTableFields
